<template>
  <div class="ai-loading-message">
    <div class="message-header">
      <span class="sender-label">AI Assistant:</span>
    </div>
    <div class="message-content">
      <div class="message-bubble-wrapper">
        <div class="message-tail"></div>
        <div class="message-bubble">
          <div class="loading-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="19" viewBox="0 0 22 19" fill="none">
              <path d="M5.31808 10.6012L3.80556 9.0264C3.59517 8.80735 3.34498 8.62382 3.0493 8.57054C2.5745 8.4847 2.11961 8.62678 1.77559 8.97904C1.51687 9.2484 1.25531 9.52073 0.996586 9.7901L0.217579 10.6012C-0.0610441 10.8913 -0.0837865 11.4241 0.217581 11.7142C0.518949 12.0043 0.985214 12.0279 1.28658 11.7142L2.75646 10.1838C2.78773 10.1512 2.81901 10.1187 2.85028 10.0861C2.85597 10.0802 2.86165 10.0743 2.86734 10.0683C2.95263 9.97363 2.85312 10.1128 2.81048 10.1098C2.83607 10.095 2.86165 10.0802 2.88724 10.0654C2.77352 10.1128 2.75362 10.1216 2.83322 10.098C2.73371 10.1187 2.68823 10.1068 2.77352 10.1068C2.85881 10.1068 2.81616 10.1157 2.71381 10.098C2.8645 10.1305 2.56881 10.0003 2.6996 10.0831C2.83038 10.166 2.56882 9.94699 2.68254 10.0654C2.6996 10.0832 2.71666 10.1009 2.73656 10.1216L4.26045 11.7082C4.53908 11.9983 5.05083 12.022 5.32945 11.7082C5.60808 11.3945 5.63082 10.909 5.32945 10.5952L5.31808 10.6012Z" fill="#374957"/>
              <path d="M1.87512 9.62731C1.94336 12.8005 3.49284 15.7399 6.04878 17.4834C8.22658 18.9694 11.027 19.3867 13.5261 18.6319C15.013 18.1849 16.3521 17.3472 17.4524 16.2194C18.1433 15.512 17.08 14.399 16.3863 15.1094C14.7941 16.7375 12.6362 17.5752 10.4101 17.4124C8.18394 17.2496 5.97201 15.9412 4.70115 13.9727C3.86528 12.6762 3.41607 11.1843 3.37912 9.63027C3.35637 8.61791 1.84953 8.61791 1.87228 9.63027L1.87512 9.62731Z" fill="#374957"/>
              <path d="M16.6819 8.3959L18.1944 9.97067C18.4048 10.1897 18.655 10.3732 18.9507 10.4265C19.4255 10.5124 19.8804 10.3703 20.2244 10.018C20.4831 9.74866 20.7447 9.47633 21.0034 9.20696L21.7824 8.3959C22.061 8.10581 22.0838 7.57299 21.7824 7.2829C21.4811 6.99281 21.0148 6.96913 20.7134 7.2829L19.2435 8.81327C19.2123 8.84583 19.181 8.87839 19.1497 8.91095C19.144 8.91687 19.1383 8.92279 19.1327 8.92871C19.0474 9.02344 19.1469 8.88431 19.1895 8.88727C19.1639 8.90207 19.1383 8.91687 19.1128 8.93167C19.2265 8.88431 19.2464 8.87543 19.1668 8.89911C19.2663 8.87839 19.3118 8.89023 19.2265 8.89023C19.1412 8.89023 19.1838 8.88135 19.2862 8.89911C19.1355 8.86655 19.4312 8.9968 19.3004 8.91391C19.1696 8.83103 19.4312 9.05008 19.3175 8.93167C19.3004 8.91391 19.2833 8.89615 19.2634 8.87543L17.7395 7.28882C17.4609 6.99873 16.9492 6.97505 16.6705 7.28882C16.3919 7.60259 16.3692 8.08805 16.6705 8.40182L16.6819 8.3959Z" fill="#374957"/>
              <path d="M20.1249 9.50001C20.0965 6.30311 18.5612 3.33117 16.0081 1.55511C13.8218 0.036584 10.9929 -0.392629 8.47108 0.368116C6.98698 0.81805 5.64504 1.6528 4.54477 2.78059C3.8539 3.48806 4.91721 4.60105 5.61093 3.89063C7.22012 2.24482 9.40361 1.41007 11.6553 1.59359C13.9071 1.77712 16.1304 3.14469 17.3813 5.15755C18.1888 6.45999 18.6067 7.94892 18.6209 9.49705C18.6294 10.5064 20.1391 10.5094 20.1277 9.49705L20.1249 9.50001Z" fill="#374957"/>
              <path d="M5.31808 10.6012L3.80556 9.0264C3.59517 8.80735 3.34498 8.62382 3.0493 8.57054C2.5745 8.4847 2.11961 8.62678 1.77559 8.97904C1.51687 9.2484 1.25531 9.52073 0.996586 9.7901L0.217579 10.6012C-0.0610441 10.8913 -0.0837865 11.4241 0.217581 11.7142C0.518949 12.0043 0.985214 12.0279 1.28658 11.7142L2.75646 10.1838C2.78773 10.1512 2.81901 10.1187 2.85028 10.0861C2.85597 10.0802 2.86165 10.0743 2.86734 10.0683C2.95263 9.97363 2.85312 10.1128 2.81048 10.1098C2.83607 10.095 2.86165 10.0802 2.88724 10.0654C2.77352 10.1128 2.75362 10.1216 2.83322 10.098C2.73371 10.1187 2.68823 10.1068 2.77352 10.1068C2.85881 10.1068 2.81616 10.1157 2.71381 10.098C2.8645 10.1305 2.56881 10.0003 2.6996 10.0831C2.83038 10.166 2.56882 9.94699 2.68254 10.0654C2.6996 10.0832 2.71666 10.1009 2.73656 10.1216L4.26045 11.7082C4.53908 11.9983 5.05083 12.022 5.32945 11.7082C5.60808 11.3945 5.63082 10.909 5.32945 10.5952L5.31808 10.6012Z" fill="#374957"/>
              <path d="M1.87512 9.62731C1.94336 12.8005 3.49284 15.7399 6.04878 17.4834C8.22658 18.9694 11.027 19.3867 13.5261 18.6319C15.013 18.1849 16.3521 17.3472 17.4524 16.2194C18.1433 15.512 17.08 14.399 16.3863 15.1094C14.7941 16.7375 12.6362 17.5752 10.4101 17.4124C8.18394 17.2496 5.97201 15.9412 4.70115 13.9727C3.86528 12.6762 3.41607 11.1843 3.37912 9.63027C3.35637 8.61791 1.84953 8.61791 1.87228 9.63027L1.87512 9.62731Z" fill="#374957"/>
              <path d="M16.6819 8.3959L18.1944 9.97067C18.4048 10.1897 18.655 10.3732 18.9507 10.4265C19.4255 10.5124 19.8804 10.3703 20.2244 10.018C20.4831 9.74866 20.7447 9.47633 21.0034 9.20696L21.7824 8.3959C22.061 8.10581 22.0838 7.57299 21.7824 7.2829C21.4811 6.99281 21.0148 6.96913 20.7134 7.2829L19.2435 8.81327C19.2123 8.84583 19.181 8.87839 19.1497 8.91095C19.144 8.91687 19.1383 8.92279 19.1327 8.92871C19.0474 9.02344 19.1469 8.88431 19.1895 8.88727C19.1639 8.90207 19.1383 8.91687 19.1128 8.93167C19.2265 8.88431 19.2464 8.87543 19.1668 8.89911C19.2663 8.87839 19.3118 8.89023 19.2265 8.89023C19.1412 8.89023 19.1838 8.88135 19.2862 8.89911C19.1355 8.86655 19.4312 8.9968 19.3004 8.91391C19.1696 8.83103 19.4312 9.05008 19.3175 8.93167C19.3004 8.91391 19.2833 8.89615 19.2634 8.87543L17.7395 7.28882C17.4609 6.99873 16.9492 6.97505 16.6705 7.28882C16.3919 7.60259 16.3692 8.08805 16.6705 8.40182L16.6819 8.3959Z" fill="#374957"/>
              <path d="M20.1249 9.50001C20.0965 6.30311 18.5612 3.33117 16.0081 1.55511C13.8218 0.036584 10.9929 -0.392629 8.47108 0.368116C6.98698 0.81805 5.64504 1.6528 4.54477 2.78059C3.8539 3.48806 4.91721 4.60105 5.61093 3.89063C7.22012 2.24482 9.40361 1.41007 11.6553 1.59359C13.9071 1.77712 16.1304 3.14469 17.3813 5.15755C18.1888 6.45999 18.6067 7.94892 18.6209 9.49705C18.6294 10.5064 20.1391 10.5094 20.1277 9.49705L20.1249 9.50001Z" fill="#374957"/>
            </svg>
          </div>
          <p class="loading-text">Working on it<span class="dots"><span class="dot">.</span><span class="dot">.</span><span class="dot">.</span></span></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AILoadingMessage'
};
</script>

<style scoped>
.ai-loading-message {
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
}

.message-header {
  display: flex;
  gap: 8px;
  align-items: center;
  padding: 0 32px;
}

.sender-label {
  font-family: 'Inter', sans-serif;
  font-size: 10px;
  font-weight: 700;
  line-height: 12px;
  letter-spacing: 0.25px;
  color: #666;
}

.message-content {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 0 32px;
}

.message-bubble-wrapper {
  display: flex;
  align-items: center;
  padding-right: 6px;
  width: 100%;
}

.message-tail {
  width: 20.114px;
  height: 21.528px;
  margin-right: -6px;
  position: relative;
}

.message-tail::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) rotate(15deg);
  width: 0;
  height: 0;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-bottom: 18px solid #E4F3F5;
}

.message-bubble {
  display: flex;
  gap: 10px;
  align-items: center;
  background: #E4F3F5;
  border-radius: 20px;
  padding: 12px 24px;
  margin-right: -6px;
  margin-left: -2px;
}

.loading-icon {
  width: 24px;
  height: 24px;
  flex-shrink: 0;
}

.loading-icon svg {
  display: block;
  animation: spin 2s linear infinite;
  transform-origin: center center;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.loading-text {
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #666;
  text-align: left;
  margin: 0;
  white-space: nowrap;
}

.dots {
  display: inline-block;
}

.dot {
  opacity: 0;
}

.dot:nth-child(1) {
  animation: blink1 2.5s infinite;
}

.dot:nth-child(2) {
  animation: blink2 2.5s infinite;
}

.dot:nth-child(3) {
  animation: blink3 2.5s infinite;
}

@keyframes blink1 {
  0%, 20% {
    opacity: 0;
  }
  20.01%, 80% {
    opacity: 1;
  }
  80.01%, 100% {
    opacity: 0;
  }
}

@keyframes blink2 {
  0%, 40% {
    opacity: 0;
  }
  40.01%, 80% {
    opacity: 1;
  }
  80.01%, 100% {
    opacity: 0;
  }
}

@keyframes blink3 {
  0%, 60% {
    opacity: 0;
  }
  60.01%, 80% {
    opacity: 1;
  }
  80.01%, 100% {
    opacity: 0;
  }
}
</style>
